import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "cardNumber", "brandIcons",
    "visaIcon", "mastercardIcon", "eloIcon", "hipercardIcon", "dinersIcon"
  ]

  connect() {
    this.currentBrand = null
  }

  updateCardBrand(event) {
    const cardType = event.detail?.type || 'unknown'

    // Reset all icons to faded
    this.resetIcons()

    // Map Cleave card types to our icons
    const brandMap = {
      'visa': 'visaIcon',
      'mastercard': 'mastercardIcon',
      'elo': 'eloIcon',
      'hipercard': 'hipercardIcon',
      'diners': 'dinersIcon',
      'amex': null,
      'discover': null,
      'jcb': null,
      'unknown': null
    }

    const iconTarget = brandMap[cardType]

    if (iconTarget && this[`has${this.capitalize(iconTarget)}Target`]) {
      const icon = this[`${iconTarget}Target`]
      icon.classList.remove('opacity-30')
      icon.classList.add('opacity-100', 'scale-110')
      this.currentBrand = cardType
    } else {
      this.currentBrand = null
    }
  }

  resetIcons() {
    const icons = ['visaIcon', 'mastercardIcon', 'eloIcon', 'hipercardIcon', 'dinersIcon']
    icons.forEach(iconName => {
      const targetName = `has${this.capitalize(iconName)}Target`
      if (this[targetName]) {
        const icon = this[`${iconName}Target`]
        icon.classList.remove('opacity-100', 'scale-110')
        icon.classList.add('opacity-30')
      }
    })
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}
